export default __webpack_public_path__ + "static/media/cinemaImage.62b6b5a9.jpg";